import React, { useEffect } from 'react';
import Modal from '@omilia/modal';
import { reduxForm, InjectedFormProps } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

// @ts-ignore
import { fetchEnvironmentsList } from 'store/services/environments/actions';
import { getEnvironmentsList } from 'store/services/environments/selectors';
import { EnvironmentItem } from 'scenes/ProjectSettings/scenes/Environments/EnvironmentsList/Environment/types';
import FORM_NAMES from 'constants/formNames';
import Wizard from './Wizard';
import useUploadProject from './hooks/useUploadModal';
import validate from '../validate';
import { UploadProjectModalFormValues } from '../types';

interface UploadProjectModalProps
  extends InjectedFormProps<UploadProjectModalFormValues> {
  willDeploy: boolean;
  onClose: () => void;
  fetchEnvironmentsList: () => void;
  environmentsList: EnvironmentItem[];
}

const UploadProjectModal = ({
  onClose,
  pristine,
  invalid,
  fetchEnvironmentsList,
  environmentsList,
  handleSubmit,
  change,
}: UploadProjectModalProps) => {
  const { uploadProjectState, uploadProject } = useUploadProject();
  useEffect(() => {
    fetchEnvironmentsList();
  }, [fetchEnvironmentsList]);

  const handleUploadProject = async (values: UploadProjectModalFormValues) =>
    uploadProject({
      applicationName: values.applicationName,
      password: values.password,
      environmentId: values.deploymentEnvironment,
      description: values.description,
    });

  const {
    primaryAction,
    secondaryActions,
    title,
    content,
    glyph,
    variant,
  } = Wizard({
    pristine,
    invalid,
    onClose,
    uploadProject: handleSubmit(handleUploadProject),
    environmentsList,
    uploadProjectState,
    change,
  });

  return (
    <Modal
      open
      shouldCloseOnBackdropClick
      glyph={glyph}
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
      title={title}
      variant={variant}
    >
      {content}
    </Modal>
  );
};

// @ts-ignore
const mapStateToProps = state => {
  const environmentsList = getEnvironmentsList(state);
  const deploymentEnvironmentInitialValue =
    environmentsList.length > 0 ? environmentsList[0].id : '';

  return {
    initialValues: {
      applicationName: environmentsList[0]?.app_name || '',
      deploymentEnvironment: deploymentEnvironmentInitialValue,
    },
    validate,
    environmentsList: getEnvironmentsList(state),
  };
};

const mapDispatchToProps = {
  fetchEnvironmentsList,
};

export default compose<UploadProjectModalProps>(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm<UploadProjectModalFormValues, UploadProjectModalProps>({
    form: FORM_NAMES.DEPLOY.UPLOAD,
    enableReinitialize: true,
    validate,
    touchOnBlur: true,
    touchOnChange: true,
    destroyOnUnmount: true,
  }),
)(UploadProjectModal);
